module.exports = "<div style=\"min-height: 5px\">    \n    <div [id]=\"targetDiv\"></div>\n</div>"